const tracksNL = {
    "view": {
        "table": {
            "title": "Bewerk Tracks",
            "column": {
                "name": "Naam",
                "mixName": "Mix Naam",
                "mixLength": "Mix Lengte",
                "player": "Speler",
                "status": "Status",
                "accStatus": "Acc Status",
                "qc": "QC",
                "action": "Actie"
            },
            "button": {
                "edit": "Bewerk",
                "goToReleases": "Ga naar Releases",
                "distribute": "Distribueer",
                "submitEditing": "Bewerken Indienen",
                "statusReady": "Klaar",
                "statusNotReady": "Niet Klaar"
            },
            "message": {
                "identityNotCheckedTooltip": "U heeft uw volledige informatie nog niet verstrekt, daarom kunt u de releases niet distribueren. Dien alstublieft uw informatie in om dit te doen.",
                "tracksNotReadyTooltip": "Dien alstublieft de metadata voor alle tracks in om de release te distribueren.",
                "tracksNotReadyForEditingTooltip": "Dien alstublieft de metadata voor alle tracks in om de bewerkingen in te dienen.",
                "distributionDisabledPreScanInProgressTooltip": "Gelieve te wachten tot de pre scan is voltooid voordat u de release kunt distribueren.",
                "distributionDisabledPreScanNotDoneTooltip": "Gelieve de pre scan eerst uit te voeren om de release te distribueren.",
                "distributionDisabledPreScanDeclarationNotSubmittedTooltip": "Gelieve de pre-scan verklaring eerst in te dienen om de release te distribueren.",
                "browserNotSupported": "Uw browser ondersteunt het audio-element niet.",
                "trackUpdated": "Track is bijgewerkt!"
            },
            "modal": {
                "distribute": {
                    "header": "Weet u zeker dat alle ingevoerde informatie geldig is en deze release volledig vertegenwoordigt?",
                    "body": {
                        "point1": "Na deze actie wordt uw release gecontroleerd en als de informatie correct is, wordt deze gedistribueerd op de officiële en exclusieve distributiedata.",
                        "point2": "Door dit formulier te bevestigen en te accepteren, accepteert u volledig en voldoet u aan de <1>Distributievoorwaarden</1>, <3>Gebruiksvoorwaarden</3> en <5>Privacybeleid</5>.",
                        "point3": "Door dit formulier te bevestigen en te accepteren, bevestigt u onbetwistbaar dat de ingediende inhoudsrelease met bijbehorende assets, audiobestanden en metadata, ofwel exclusief van u is of volledig is gelicentieerd aan uw label.",
                        "point4": "Hierbij accepteert u volledig dat u als enige verantwoordelijk bent voor eventuele misleidende informatie, ongeoorloofd gebruik, illegale activiteiten of enige vorm van geschil.",
                        "flaggedTracksTerms": {
                            "header": "Voorwaarden voor Gemarkeerde Tracks",
                            "point1": "Let op: <strong>'{{releaseName}}'</strong> bevat een of meer gemarkeerde tracks. Er geldt een vergoeding van <strong>15 €</strong> per gemarkeerde track om de release naar <strong>Spotify</strong> te leveren. Aangezien u ervoor heeft gekozen deze vergoeding op dit moment niet te betalen, wordt de release niet naar Spotify geleverd. Door dit formulier te bevestigen en te accepteren, erkent en accepteert u deze voorwaarden.",
                            "point2": "In de toekomst, als u ervoor kiest om de release naar <strong>Spotify</strong> te laten leveren, kunt u naar de Gemarkeerde sectie in de Releases-tabel gaan en de betalingsinstructies volgen."
                        },
                        "artificialStreamingDeclaration": {
                            "header": "Verklaring Kunstmatige Streaming",
                            "point1": "<strong>1.</strong> Ik begrijp volledig en ga ermee akkoord om niet deel te nemen aan enige vorm van kunstmatige streaming, inclusief het gebruik van bots, streaming farms of enige methode die DSP-metrics manipuleert.",
                            "point2": "<strong>2.</strong> Ik zal niet betalen of betaling aanbieden voor playlistplaatsingen, noch zal ik samenwerken met een derde partij die gegarandeerde plaatsingen belooft — ik begrijp dat dit als fraude en oplichting wordt beschouwd.",
                            "point3": "<strong>3.</strong> Ik erken dat dergelijke acties kunnen leiden tot onmiddellijke beëindiging, verlies van royalty's, juridische claims, contractuele boetes en kosten, en rapportage aan DSP's en autoriteiten.",
                            "point4": "<strong>4.</strong> Ik garandeer ook om eventuele artiesten of klanten waarmee ik werk over deze regels te informeren en ervoor te zorgen dat zij zich eraan houden.",
                            "point5": "<strong>5.</strong> Ik begrijp dat als ik me bezighoud met kunstmatige streaming, mijn KYC-gegevens, inclusief mijn volledige naam, adres, identiteitskaart en andere persoonlijke informatie, kunnen worden gedeeld met de juridische afdelingen van de DSP's, zoals die van Spotify, Apple Music en anderen.",
                            "point6": "<strong>6.</strong> Ik accepteer volledige juridische verantwoordelijkheid voor eventuele overtredingen.",
                            "acknowledgment": "Ik erken hierbij en ga akkoord met de bovenstaande voorwaarden voor Kunstmatige Streaming, en ik accepteer volledige juridische verantwoordelijkheid voor eventuele overtredingen."
                        }
                    },
                    "button": {
                        "cancel": "Annuleren",
                        "confirm": "Bevestigen en Accepteren"
                    }
                },
                "finishEditing": {
                    "header": "Weet u zeker dat alle ingevoerde informatie geldig is en deze release volledig vertegenwoordigt?",
                    "body": {
                        "point1": "Na deze actie wordt uw release gecontroleerd en als de informatie correct is, wordt deze opnieuw gedistribueerd naar de DSP-partners. <strong>LET OP, alleen METADATA wordt naar DSP's gestuurd, inhoud zoals AFBEELDING en AUDIO-bestanden kunnen op deze manier niet worden bijgewerkt.</strong>",
                        "point2": "Door dit formulier te bevestigen en te accepteren, accepteert u volledig en voldoet u aan de <1>Gebruiksvoorwaarden</1> en de voorwaarden van onze Exclusieve Distributieovereenkomst.",
                        "point3": "Door dit formulier te bevestigen en te accepteren, accepteert u volledig en voldoet u aan het <1>Privacybeleid</1>.",
                        "point4": "Door dit formulier te bevestigen en te accepteren, bevestigt u onbetwistbaar dat de ingediende inhoudsrelease met bijbehorende assets, audiobestanden en metadata, ofwel exclusief van u is of volledig is gelicentieerd aan uw label.",
                        "point5": "Hierbij accepteert u volledig dat u als enige verantwoordelijk bent voor eventuele misleidende informatie, ongeoorloofd gebruik, illegale activiteiten of enige vorm van geschil."
                    },
                    "button": {
                        "cancel": "Annuleren",
                        "confirm": "Bevestigen en Accepteren"
                    }
                }
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "title": "Bewerk track {{trackName}}",
                "mandatoryMetadata": "Verplichte Metadata",
                "required": "Vereist",
                "trackName": "Track Naam",
                "mixName": "Mix Naam",
                "originalmix": "Originele Mix",
                "remix": "Dit is een Remix of Mix",
                "vocals": "Vocalen",
                "genre": "Genre",
                "subGenre": "Sub-Genre",
                "additionalMetadata": "Aanvullende Metadata",
                "copyright": "Copyright ©",
                "copyrightYear": "Copyright Jaar",
                "albumOnly": "Alleen Album",
                "explicitContent": "Expliciete Inhoud",
                "isrc": "ISRC",
                "daIsrc": "Dolby Atmos ISRC",
                "generateIsrc": "Genereer ISRC",
                "trackLanguageMetadata": "Track Taal Metadata",
                "language": "Taal",
                "autoDetectLanguage": "Automatisch Detecteren (Taal)",
                "accountingData": "Boekhoudgegevens",
                "labelShare": "Label Aandeel (%)"
            },
            "placeholder": {
                "select": "Selecteer...",
                "labelShare": "bijv. 50"
            },
            "help_text": {
                "trackName": "Titel van de track",
                "mixName": "Voer de mixnaam in zonder haakjes. Sommige tracks worden in meer dan één versie uitgebracht. Dit veld beschrijft de versie, bijvoorbeeld 'Bunte Bummler - Aesub (Monika Ross Remix)",
                "vocals": "Luister naar uw track in volledige lengte. Als uw track vocalen bevat, selecteer dan de taal van de vocalen. Als uw track vrij is van vocalen, selecteer dan de optie Instrumentaal. Controleer het dubbel om zeker te zijn. Als deze invoer verkeerd is, zullen sommige winkels zoals iTunes en Apple Music de release afwijzen.",
                "publishers": {
                    "publisherName": "<strong>Uitgever naam:</strong> Voer de volledige naam van de uitgeverij in als u gebruikmaakt van uitgeversdiensten.  Als u geen gebruikmaakt van officiële uitgeversdiensten, voer/selecteer dan <strong>Copyright Control</strong> in. Voer <strong>uw labelnaam niet in</strong> als het geen geregistreerd uitgeversbedrijf is. Juridische implicaties kunnen van toepassing zijn.",
                    "authorSongWriterName": "<strong>Auteur / Songwriter volledige naam:</strong> Voer de <strong>echte Voor- en Achternaam</strong> van de persoon in."
                },
                "contributors": {
                    "contributorsName": "<strong>Naam bijdragers:</strong> Voer de <strong>echte Voor- en Achternaam</strong> van de persoon in.",
                    "contributorsRoles": "<strong>Bijdragers rollen:</strong> Er moet ten minste één bijdrager worden toegevoegd als <strong>Componist</strong>. Als uw track vocalen bevat, moet ten minste één bijdrager worden toegevoegd als <strong>Componist</strong> en één bijdrager moet worden toegevoegd als <strong>Tekstschrijver</strong>."
                },
                "copyright": "Naam van de copyright houder",
                "albumOnly": "Geeft aan of de track alleen als onderdeel van een bundelrelease wordt verkocht. Houd er rekening mee dat sommige winkels deze instructie kunnen negeren",
                "explicitContent": "Markeer dit veld als de track verboden teksten bevat",
                "isrc": "De Internationale Standaard Opnamecode toegewezen aan de track. Als u er geen heeft, zullen wij er een voor u genereren",
                "daIsrc": "De Internationale Standaard Opnamecode toegewezen aan de track. Als u er geen heeft, zullen wij er een voor u genereren",
                "language": "In welke taal is de tracknaam geschreven? Controleer het dubbel als u niet zeker bent. Als deze invoer verkeerd is, zullen sommige winkels zoals iTunes en Apple Music de release afwijzen.",
                "labelShare": "<strong>Tip:</strong> De industriestandaard voor <strong>label aandeel</strong> is <strong>50%</strong> en <strong>50%</strong> voor de <strong>aandeelhouders</strong>. We raden u sterk aan om het juiste percentage aandeel in te voeren waarover u met uw artiesten, aandeelhouders en partners bent overeengekomen.",
                "costTypes": {
                    "point1": "Voer alleen daadwerkelijke, opgetreden of vooraf overeengekomen <strong>Kosten</strong> per track in. We raden u sterk aan om geen valse kosten in te voeren.",
                    "point2": "<strong>Kostentypen</strong> kunnen elke vaste of variabele kosten zijn, bijv. <strong>Audio Mastering, Grafisch Ontwerp, Promotie, Marketing</strong>, of andere levensvatbare uitgaven gedaan voor de specifieke <strong>Track</strong> door het <strong>Label</strong>."
                }
            },
            "button": {
                "submitTrack": "Track Indienen"
            },
            "message": {
                "successArtistAdded": "Een nieuwe Artiest is toegevoegd!",
                "successPublisherAdded": "Een nieuwe Uitgever is toegevoegd!",
                "successContributorAdded": "Een nieuwe Bijdrager is toegevoegd!",
                "successShareholderAdded": "Een nieuwe Aandeelhouder is toegevoegd!",
                "successCostTypeAdded": "Een nieuw Kostentype is toegevoegd!",
                "errorLabelShareInvalid": "Voer een geldige waarde in (1-100)",
                "errorFormCannotBeSubmitted": "Formulier kan niet worden ingediend! Vul alle velden in en controleer op fouten!",
                "accountingMetadata": {
                    "title": "WAARSCHUWING",
                    "description": {
                        "point1": "OPTIONELE METADATA - vul dit deel van de metadata alleen in als u boekhoudrapporten aan uw artiesten of aandeelhouders zult uitgeven!",
                        "point2": "Zorg ervoor dat de ingediende gegevens in deze sectie volledig nauwkeurig zijn, aangezien dit van invloed zal zijn op de rapporten die u naar uw artiesten en aandeelhouders stuurt.",
                        "point3": "We raden sterk aan om de invoer dubbel te controleren, aangezien na indiening aanvullende bewerkingen en wijzigingen niet worden aanbevolen voor de nauwkeurigheid van de gegevens.",
                        "point4": "Boekhoudrapporten voor uw artiesten en aandeelhouders zullen alleen een nauwkeurig effect hebben als u alle parameters correct en volgens uw afspraken met uw artiesten en aandeelhouders indient.",
                        "point5": "Kosten kunnen slechts één keer worden toegevoegd en kunnen later niet worden bewerkt om redenen van transparantie en nauwkeurigheid. Zorg ervoor dat u alle trackkosten nauwkeurig bij uw eerste poging invoert."
                    }
                }
            }
        }
    },
    "publishersRow": {
        "form": {
            "label": {
                "publishers": "Uitgevers",
                "required": "Vereist",
                "order": "Volgorde",
                "publisherName": "Uitgever naam",
                "authorSongWriterName": "Auteur / Songwriter volledige naam"
            },
            "placeholder": {
                "publisherName": "Selecteer Uitgever..."
            },
            "button": {
                "addAnother": "Voeg nog een toe",
                "createNew": "Nieuw maken?",
                "remove": "Verwijderen"
            },
            "message": {
                "publisherRequired": "Selecteer alstublieft een uitgever",
                "authorSongWriterRequired": "Voer de echte Voor- en Achternaam van de persoon in."
            },
            "modal": {
                "header": "Voeg nieuwe Uitgever toe",
                "body": {
                    "label": {
                        "name": "Naam"
                    },
                    "message": {
                        "nameRequired": "Naam is vereist",
                        "publisherAlreadyExists": "Uitgever bestaat al"
                    }
                },
                "button": {
                    "createNew": "Nieuw maken",
                    "cancel": "Annuleren"
                }
            }
        }
    },
    "contributorsRow": {
        "form": {
            "label": {
                "contributors": "Bijdragers",
                "required": "Vereist",
                "order": "Volgorde",
                "contributorName": "Bijdrager volledige naam",
                "contributorRole": "Bijdrager rol"
            },
            "placeholder": {
                "contributorName": "Selecteer Bijdrager..."
            },
            "button": {
                "addAnother": "Voeg nog een toe",
                "createNew": "Nieuw maken?",
                "remove": "Verwijderen"
            },
            "modal": {
                "header": "Voeg nieuwe Bijdrager toe",
                "body": {
                    "label": {
                        "name": "Naam"
                    },
                    "help_text": {
                        "name": "Voer de volledige Voor- en Achternaam van de songwriter in. Voorbeeld: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Naam is vereist",
                        "nameMustNotBeInUppercase": "Naam mag niet volledig in hoofdletters zijn",
                        "insertRealName": "Voer de echte Voor- en Achternaam van de persoon in.",
                        "errorContributorAlreadyExists": "Bijdrager bestaat al"
                    }
                },
                "button": {
                    "createNew": "Nieuw maken",
                    "cancel": "Annuleren"
                }
            }
        }
    },
    "shareholdersRow": {
        "form": {
            "label": {
                "order": "Volgorde",
                "shareholders": "Aandeelhouders",
                "shareholderName": "Aandeelhouder Naam",
                "shareholderSplit": "Aandeelhouder Verdeling (%)",
                "shareholderRoles": "Aandeelhouder Rollen"
            },
            "placeholder": {
                "shareholderName": "Selecteer Aandeelhouder...",
                "shareholderSplit": "bijv. 50"
            },
            "message": {
                "shareholderRequired": "Selecteer alstublieft een aandeelhouder",
                "shareholderSplitRequired": "Voer een geldige waarde in (1-100)",
                "shareholderRolesRequired": "Selecteer alstublieft ten minste één rol",
                "shareSum": "Label Aandeel en Aandeelhouder Verdelingen moeten samen 100% zijn"
            },
            "button": {
                "addAnother": "Voeg nog een toe",
                "createNew": "Nieuw maken?",
                "remove": "Verwijderen"
            },
            "modal": {
                "header": "Voeg nieuwe Aandeelhouder toe",
                "body": {
                    "label": {
                        "name": "Naam",
                        "email": "E-mail"
                    },
                    "help_text": {
                        "name": "Voer de volledige Voor- en Achternaam van de songwriter in. Voorbeeld: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Naam is vereist",
                        "emailRequired": "E-mail is vereist",
                        "emailInvalid": "E-mail is niet geldig"
                    }
                },
                "button": {
                    "createNew": "Nieuw maken",
                    "cancel": "Annuleren"
                }
            }
        }
    },
    "costTypesRow": {
        "form": {
            "label": {
                "costTypes": "Kostentypen",
                "order": "Volgorde",
                "costType": "Kostentype",
                "cost": "Kosten (€)"
            },
            "placeholder": {
                "costType": "Selecteer Kostentype...",
                "cost": "bijv. -7.5"
            },
            "button": {
                "addAnother": "Voeg nog een toe",
                "createNew": "Nieuw maken?",
                "remove": "Verwijderen"
            },
            "message": {
                "costTypeRequired": "Selecteer alstublieft een kostentype",
                "costNotNegative": "Voer een negatieve waarde in, bijv. -10.0"
            },
            "modal": {
                "header": "Voeg Nieuw Kostentype toe",
                "body": {
                    "label": {
                        "name": "Naam"
                    },
                    "message": {
                        "nameRequired": "Naam is vereist",
                        "costTypeAlreadyExists": "Kostentype bestaat al"
                    },
                    "button": {
                        "createNew": "Nieuw maken",
                        "cancel": "Annuleren"
                    }
                }
            }
        }
    }
};

export default tracksNL;